export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./kra.vue?vue&type=template&id=1451f56d"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/kra.vue?vue&type=template&id=1451f56d
// module id = 6dNw
// module chunks = 0